import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'

export class CometApiService extends ApiService {
  /**
   * Get all Comet competitions
   */
  static async getCompetitions(data: object): Promise<AxiosResponse> {
    return this.axios.get('external/comet/competitions-search', { params: data })
      .then((response: AxiosResponse) => response.data)
  }

  /**
   * Get specific Comet competition details
   *
   * @param data
   */
  static async getCompetitionTable(data: object): Promise<AxiosResponse> {
    return this.axios.get('external/comet/competitions-table', { params: data })
      .then((response: AxiosResponse) => response.data)
  }

  /**
   * Search for Comet players
   *
   * @param keyword string
   * @param teamId string (optional)
   */
  static async searchPlayers(keyword: string, teamId?: string): Promise<AxiosResponse> {
    const params: any = {}

    if (keyword) {
      params.keyword = keyword
    }

    if (teamId) {
      params.team_id = teamId
    }

    return this.axios.get('external/comet/players', { params })
      .then((response: AxiosResponse) => response.data)
  }

  static async getPlayerById(id: string): Promise<AxiosResponse> {
    const params: any = {
      id: id
    }

    return this.axios.get('external/comet/player', {
      params
    }).then((response: AxiosResponse) => response.data)
  }

  static async getCompetitionMatches(data: object): Promise<AxiosResponse> {
    return this.axios.get('external/comet/competitions-matches', { params: data })
      .then((response: AxiosResponse) => response.data)
  }

  static async getMatches(data: object): Promise<AxiosResponse> {
    return this.axios.get('external/comet/matches', { params: data })
      .then((response: AxiosResponse) => response.data)
  }
}
